import { getString } from "common/ui_string_labels/ui-strings-utils";

/**
 * Represents the navigation pages of the website
 * @interface
 * @property {string} name - The name of the page
 * @property {string} url - The url of the page
 */
export interface Page {
    name: string;
    url: string;
}

export default class Paths {
    static readonly itHardwareRestock: Page = {
        name: getString("views.itHardwareRestock.title"),
        url: "/hardware_restock",
    };
    static readonly itOrderConfirmation: Page = {
        name: getString("views.itOrderConfirmation.title"),
        url: "/hardware_restock/new",
    };
    static readonly itOrderList: Page = { name: getString("views.itOrderList.title"), url: "/" };

    static readonly defaultPagePath = Paths.itOrderList.url;
}
